import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import DemoView from "../views/DemoView.vue";
import WaitView from "../views/WaitView.vue";
import FormView from "../views/FormView.vue";
import FinishView from "../views/FinishView.vue";
import Form2View from "../views/Form2View.vue";
import ChoiceView from "../views/ChoiceView.vue";
import PerduView from "../views/PerduView.vue";
import WinView from "../views/WinView.vue";
import WinVoyageView from "../views/WinVoyageView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import ContactView from "../views/ContactView.vue";
import DotationView from "../views/DotationView.vue";
import CodePerdantView from "../views/CodePerdantView.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/home",
    component: HomeView,
  },
  {
    path: "/demo",
    name: "demo",
    component: DemoView,
  },
  {
    path: "/status/:_id/:uid",
    alias: "/status/:_id/:uid",
    name: "win",
    component: WinView,
  },
  {
    path: "/gagner-voyage",
    name: "gagner-voyage",
    component: WinVoyageView,
  },
  {
    path: "/choice",
    name: "choice",
    component: ChoiceView,
  },
  {
    path: "/perdu",
    name: "perdu",
    component: PerduView,
  },
  {
    path: "/code-perdant",
    name: "code-perdant",
    component: CodePerdantView,
  },
  {
    path: "/wait",
    name: "wait",
    component: WaitView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/dotations",
    name: "dotations",
    component: DotationView,
  },
  {
    path: "/form",
    name: "form",
    component: FormView,
  },
  {
    path: "/formig",
    name: "formig",
    component: Form2View,
  },
  {
    path: "/finish",
    name: "finish",
    component: FinishView,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash, behavior: "smooth" };
    }
    return { x: 0, y: 0 };
  },
});

// Dates de l'opération : du 01/05/2026 00:00 au 28/02/2027 23:59 inclus
const OPERATION_START = new Date(2026, 4, 1, 0, 0, 0);
const OPERATION_END = new Date(2027, 2, 1, 0, 0, 0);

router.beforeEach((to, from, next) => {
  const now = new Date();

  if (now < OPERATION_START) {
    if (to.name !== "wait") {
      return next({ name: "wait" });
    }
    return next();
  }

  if (now >= OPERATION_END) {
    if (to.name !== "finish") {
      return next({ name: "finish" });
    }
    return next();
  }

  next();
});

export default router;
